import React from 'react';
import {
  map,
  concat,
  remove,
  isEmpty,
  difference,
  head,
  find,
  isUndefined,
  forEach
} from 'lodash';
import classNames from 'classnames';
import { Row, Col, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { connect } from '../../../reducers/index';
// import ClickableScreenReader from '../../ScreenReader/ClickableScreenReader';
import UnClickableScreenReader from '../../ScreenReader/UnClickableScreenReader';

import './styles.css';

class SingleSelectQuestions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      quetionId: null,
      isSubmited: false,
      optionId: [],
      isCorrect: false,
      type: this.props.type,
      A: { isSelected: false },
      B: { isSelected: false },
      C: { isSelected: false },
      D: { isSelected: false },
      E: { isSelected: false },
      F: { isSelected: false },
      G: { isSelected: false },
      H: { isSelected: false },
      I: { isSelected: false }
    };
    this.changeOptions = this.changeOptions.bind(this);
    this.changeSingleOptions = this.changeSingleOptions.bind(this);
    this.onSubmitAnswer = this.onSubmitAnswer.bind(this);
  }
  changeSingleOptions(event) {
    if (
      this.state[event.target.value || event.target.getAttribute('value')]
        .isSelected
    ) {
      this.setState({
        optionId: remove(
          this.state.optionId,
          n => n !== event.target.value || event.target.getAttribute('value')
        )
      });
    } else {
      this.setState({
        [head(this.state.optionId)]: { isSelected: false },
        optionId: [event.target.value || event.target.getAttribute('value')]
      });
    }
    this.setState({
      [event.target.value || event.target.getAttribute('value')]: {
        isSelected: !this.state[
          event.target.value || event.target.getAttribute('value')
        ].isSelected
      }
    });
  }
  changeOptions(event) {
    if (
      this.state[event.target.value || event.target.getAttribute('value')]
        .isSelected
    ) {
      this.setState({
        optionId: remove(
          this.state.optionId,
          n => n !== event.target.value || event.target.getAttribute('value')
        )
      });
    } else {
      this.setState({
        optionId: concat(
          this.state.optionId,
          event.target.value || event.target.getAttribute('value')
        )
      });
    }
    this.setState({
      [event.target.value || event.target.getAttribute('value')]: {
        isSelected: !this.state[
          event.target.value || event.target.getAttribute('value')
        ].isSelected
      }
    });
  }
  onSubmitAnswer() {
    const { questions } = this.props;
    const { optionId } = this.state;
    let selectedAny = false;

    forEach(optionId, item => {
      if (this.state[item].isSelected) {
        selectedAny = true;
      }
    })

    if (selectedAny) {
      this.setState({ isSubmited: true });
      const differ =
        questions.result.length > optionId.length
          ? difference(questions.result, optionId)
          : difference(optionId, questions.result);
      if (isEmpty(differ)) {
        this.setState({
          isCorrect: true
        });
      }
    }
  }

  render() {
    const {
      questions,
      options,
      questionType,
      categoary,
      showLetter,
      nextRoute,
      previousRoute
    } = this.props;
    const textColor = classNames({
      'txt-purple': questionType === 'identify',
      'txt-green': questionType === 'assist',
      'txt-blue': questionType === 'refer'
    });
    const btnColor = classNames({
      'btn-purple': questionType === 'identify',
      'btn-green': questionType === 'assist',
      'btn-blue': questionType === 'refer'
    });

    const renderOptions = map(options, (item, index) => {
      if (categoary === 'survey') {
        if (showLetter === false) {
          return (
            <div className="col-md-4" key={index}>
              <li className="col-xs-12">
                <input
                  type="radio"
                  name={item.prefix}
                  id={item.prefix}
                  value={item.prefix}
                  onClick={
                    questions.type === 'single'
                      ? this.changeSingleOptions
                      : this.changeOptions
                  }
                  disabled={this.state.isSubmited}
                />
                <label
                  className={
                    this.state[item.prefix].isSelected ? 'selected' : ''
                  }
                  htmlFor={item.prefix}
                  style={{ textAlign: 'center', padding: 0 }}
                >
                  {/*                  <ClickableScreenReader
                    text={item.optionText}
                    value={item.prefix}
                    event={true}
                    disabled={this.state.isSubmited}
                    handleEvent={
                      questions.type === 'single'
                        ? this.changeSingleOptions
                        : this.changeOptions
                    }
                  />*/}
                  <UnClickableScreenReader text={item.optionText} />
                  <p>{item.optionText}</p>
                </label>
              </li>
            </div>
          );
        } else {
          return (
            <div className="col-md-4" key={index}>
              <li className="col-xs-12">
                <input
                  type="radio"
                  name={item.prefix}
                  id={item.prefix}
                  value={item.prefix}
                  onClick={
                    questions.type === 'single'
                      ? this.changeSingleOptions
                      : this.changeOptions
                  }
                  disabled={this.state.isSubmited}
                />
                <label
                  className={
                    this.state[item.prefix].isSelected ? 'selected' : ''
                  }
                  htmlFor={item.prefix}
                >
                  <p>
                    <span className="letter">{item.prefix}</span>{' '}
                    {/*<ClickableScreenReader
                      text={item.optionText}
                      value={item.prefix}
                      event={true}
                      disabled={this.state.isSubmited}
                      handleEvent={
                        questions.type === 'single'
                          ? this.changeSingleOptions
                          : this.changeOptions
                      }
                    />*/}
                    <UnClickableScreenReader text={item.optionText} />
                    {item.optionText}
                  </p>
                </label>
              </li>
            </div>
          );
        }
      } else if (index % 2 === 0) {
        return (
          <div key={index}>
            {this.state.isSubmited && (
              <li className="col-md-1 hidden-sm hidden-xs">
                {this.state.isSubmited &&
                  this.state[item.prefix].isSelected && (
                    <span aria-label={item.result} className={item.result} />
                  )}
              </li>
            )}
            <li
              className={
                this.state.isSubmited
                  ? 'col-md-5 col-xs-12'
                  : 'col-md-5 col-xs-12 col-md-offset-1'
              }
            >
              <input
                type="radio"
                name={item.prefix}
                id={item.prefix}
                value={item.prefix}
                onClick={
                  questions.type === 'single'
                    ? this.changeSingleOptions
                    : this.changeOptions
                }
                disabled={this.state.isSubmited}
              />
              <label
                className={this.state[item.prefix].isSelected ? 'selected' : ''}
                htmlFor={item.prefix}
              >
                <p>
                  <span className="letter">{item.prefix}</span>{' '}
                  {/*<ClickableScreenReader
                    text={item.optionText}
                    value={item.prefix}
                    disabled={this.state.isSubmited}
                    event={true}
                    handleEvent={
                      questions.type === 'single'
                        ? this.changeSingleOptions
                        : this.changeOptions
                    }
                  />*/}
                  <UnClickableScreenReader text={item.optionText} />
                  {item.optionText}
                </p>
              </label>
            </li>
          </div>
        );
      }

      return (
        <div key={index}>
          <li className="col-md-5 col-xs-12">
            <input
              type="radio"
              name={item.prefix}
              id={item.prefix}
              value={item.prefix}
              onClick={
                questions.type === 'single'
                  ? this.changeSingleOptions
                  : this.changeOptions
              }
              disabled={this.state.isSubmited}
            />
            <label
              className={this.state[item.prefix].isSelected ? 'selected' : ''}
              htmlFor={item.prefix}
            >
              <p>
                {/*<ClickableScreenReader
                  text={item.optionText}
                  value={item.prefix}
                  event={true}
                  disabled={this.state.isSubmited}
                  handleEvent={
                    questions.type === 'single'
                      ? this.changeSingleOptions
                      : this.changeOptions
                  }
                />*/}
                <UnClickableScreenReader text={item.optionText} />
                <span className="letter">{item.prefix}</span> {item.optionText}
              </p>
            </label>
          </li>
          {this.state.isSubmited && (
            <li className="col-md-1 hidden-sm hidden-xs">
              {this.state.isSubmited && this.state[item.prefix].isSelected && (
                <span aria-label={item.result} className={item.result} />
              )}
            </li>
          )}
        </div>
      );
    });

    return (
      <div>
        <section>
          <div className="container quiz-question" role="questionnaire">
            <Row className="text-center">
              <Col xs={10} xsOffset={1}>
                {questions.title ? (
                  <UnClickableScreenReader text={questions.title} />
                ) : null}
                <h2 className={`${textColor} no-bold`}>{questions.title}</h2>

                <p>{questions.text}</p>
              </Col>
            </Row>
            <ul className="row">{renderOptions}</ul>
            {!this.state.isSubmited && categoary !== 'survey' && (
              <Row>
                <Col xs={10} xsOffset={1} className="text-center">
                  <Button
                    className="btn btn-blue center"
                    onClick={this.onSubmitAnswer}
                  >
                    Submit
                  </Button>
                </Col>
              </Row>
            )}
            {this.state.isSubmited && (
              <div className="container quiz-answer">
                <Row>
                  <Col xs={12}>
                    <div className="text-center">
                      {this.state.isCorrect ? (
                        <div style={{ display: 'flex', marginBottom: '10px' }}>
                          <div
                            aria-label="correct"
                            className="correct txt-green"
                          />
                          <div
                            aria-label={questions.feedback.correct}
                            style={{
                              position: 'relative',
                              padding: '0px 50px'
                            }}
                          >
                            <UnClickableScreenReader
                              text={questions.feedback.correct}
                            />
                            {questions.feedback.correctNode
                              ? questions.feedback.correctNode
                              : questions.feedback.correct}
                          </div>
                        </div>
                      ) : (
                          <div style={{ display: 'flex', marginBottom: '10px' }}>
                            <div
                              aria-label="incorrect"
                              className="incorrect txt-red"
                            />
                            <div
                              aria-label={
                                questions.type === 'single' &&
                                  this.state.optionId.length > 0
                                  ? find(options, {
                                    prefix: head(this.state.optionId)
                                  }).resultText
                                  : questions.feedback.incorrectNode
                                    ? questions.feedback.incorrectNode
                                    : questions.feedback.incorrect
                              }
                              style={{
                                position: 'relative',
                                padding: '0px 50px'
                              }}
                            >
                              <UnClickableScreenReader
                                text={
                                  questions.type === 'single' &&
                                    this.state.optionId.length > 0
                                    ? find(options, {
                                      prefix: head(this.state.optionId)
                                    }).resultText
                                    : questions.feedback.incorrectNode
                                      ? questions.feedback.incorrectNode
                                      : questions.feedback.incorrect
                                }
                              />
                              {questions.type === 'single' &&
                                this.state.optionId.length > 0
                                ? find(options, {
                                  prefix: head(this.state.optionId)
                                }).resultText
                                : questions.feedback.incorrectNode
                                  ? questions.feedback.incorrectNode
                                  : questions.feedback.incorrect}
                            </div>
                          </div>
                        )}

                      {!isEmpty(questions.feedback.all) && (
                        <div aria-label={questions.feedback.all}>
                          {questions.feedback.all}
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            )}
          </div>
        </section>
        <section>
          <div className="container text-center">
            <Row>
              <Col xs={12}>
                <Button
                  className={`btn ${btnColor} previous`}
                  onClick={previousRoute}
                >
                  Previous
                </Button>
                {!isUndefined(nextRoute) &&
                  (this.state.isSubmited ||
                    (this.props.categoary === 'survey' &&
                      this.state.optionId.length > 0)) && (
                    <LinkContainer
                      to={nextRoute}
                      className={`btn ${btnColor} next`}
                    >
                      <Button>Next</Button>
                    </LinkContainer>
                  )}
              </Col>
            </Row>
          </div>
        </section>
      </div>
    );
  }
}

export default connect.role(SingleSelectQuestions);



// WEBPACK FOOTER //
// ./src/components/Questions/SingleSelectQuestions/index.jsx